import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebaseConfig';
import Login from './Login';
import Brand from './components/Brand';

const Home = () => {
  const [user] = useAuthState(auth);

  if (!user) {
    return <Login />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '32px 20px' }}>
      <Brand fontSize={24} logoSize={44} iconSize={26} />
      <p style={{ color: '#596574' }}>Welcome back, {user.email}!</p>
    </div>
  );
};

export default Home;
